import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/Usuarios.css";
import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import axios from "axios";
import { HEADERS_API } from "./NuevaGuia";
import { ValidarSesion } from "../shared/Validaciones";
import Paginador from "./components/Paginador";
import { ValidarNumLtr } from "../shared/Regex";

export default function Vehiculos(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================

    // ESTADOS DE CONTENIDO
    const[listaVehiculos, setListaVehiculos] = useState(<></>);

    // ESTADOS DE FILTRO
    const[filtroPlaca, setFiltroPlaca] = useState("");
    const[filtroDescripcion, setFiltroDescripcion] = useState("");
    const[filtroEntidad, setFiltroEntidad] = useState("");

    // ESTADOS DE LISTA
    const[selectEntidades, setSelectEntidades] = useState(<></>);

    // ESTADOS DE PAGINACIÓN
    const[paginador, setPaginador] = useState(<></>);
    //#endregion

    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
        obtenerListaEntidades();
        ObtenerListaVehiculos("", "", "", 1);
    },[]);

    //#endregion

    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    // ESTADOS DE CONTENIDO
    const HandlerListaVehiculos = (valor) => setListaVehiculos(valor);
    // ESTADOS DE FILTRO
    const HandlerFiltroPlaca = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setFiltroPlaca(valor.toUpperCase());
        }
    }
    const HandlerFiltroDescripcion = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setFiltroDescripcion(valor.toUpperCase());
        }
    }
    const HandlerFiltroEntidad = (valor) => setFiltroEntidad(valor);
    // ESTADOS DE LISTA
    const HandlerSelectEntidades = (lista) => {
        setSelectEntidades(<>{lista.map((item, index)=>(
            <option key={index} value={item.codEntidad} >{item.descEntidad}</option>
        ))}</>)
    }
    // ESTADOS DE PAGINACIÓN
    const HandlerPaginador = (valor) => setPaginador(valor);
    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    const ObtenerListaVehiculos = async(placa, descripcion, entidad, pagina) => {
        const paramPlaca = placa == "" ? "-" : placa;
        const paramDescripcion = descripcion == "" ? "-" : descripcion;
        const paramEntidad = entidad == "" ? "-" : entidad;
        try{
            const response = await axios.get(URL_LISTAR_VEHICULOS,{
                headers: HEADERS_API,
                params: {
                    fPlaca: paramPlaca,
                    fDescripcion: paramDescripcion,
                    fEntidad: paramEntidad,
                    pagina: pagina
                }
            }).catch(error => {
                throw new Error(error.message);
            });
            HandlerListaVehiculos(response.data.lista);
            if(response.data.lista.length > 0){
                const total = response.data.lista[0].total;
                const regPag = response.data.lista[0].regPag;
                const pag = response.data.lista[0].pagina;
                HandlerPaginador(<Paginador totalRegistros={total} regPag={regPag} pagina={pag} funcion={FuncionPaginador}/>);
            }else{
                HandlerPaginador(<></>);
            }
        }catch(error){
            console.log(error);
        }
    }
    const obtenerListaEntidades = async () => {
        try{
            let response = await axios.get(URL_ENTIDADES_EMISORAS,{
                headers: HEADERS_API
            }).catch(error =>{
                throw new Error(error.message);
            });

            if(response.data.mensajeError != null){
                throw new Error(response.data.mensajeError);
            }

            HandlerSelectEntidades(response.data.lista);
            HandlerFiltroEntidad("-");
        }catch(error){
            console.log(error.message);
        }
    }
    // FUNCIONES COMPLEMENTARIAS
    const QuitarFiltros = () => {
        HandlerFiltroPlaca("");
        HandlerFiltroDescripcion("");
        HandlerFiltroEntidad("-");
        ObtenerListaVehiculos("", "", "", 1);
    }
    // FUNCIÓN PAGINADOR
    const FuncionPaginador = (pagina) =>{
        ObtenerListaVehiculos(filtroPlaca, filtroDescripcion, filtroEntidad, pagina);
    }
    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className="col-12 py-3 text-center">
                <h2>VEHÍCULOS</h2>
            </div>
            <div className="col-12 py-1">
                <Link to={"/nuevo-vehiculo"}>
                    <button className="btn btn-primary">Nuevo Vehículo</button>
                </Link>
            </div>
            {/* FILTROS */}
            <div className="col-12 col-md-3 p-1">
                <div className="form-floating">
                    <input onChange={e=>HandlerFiltroDescripcion(e.target.value)} value={filtroDescripcion} maxLength={50} type="text" className="form-control text-uppercase" placeholder="Buscar" id="filtro-descripcion" autoComplete="off"/>
                    <label htmlFor="filtro-descripcion">Descripcion</label>
                </div>
            </div>
            <div className="col-12 col-md-3 p-1">
                <div className="form-floating">
                    <input onChange={e=>HandlerFiltroPlaca(e.target.value)} value={filtroPlaca} maxLength={10} type="text" className="form-control text-uppercase" placeholder="Buscar" id="filtro-placa" autoComplete="off"/>
                    <label htmlFor="filtro-placa">Placa</label>
                </div>
            </div>
            <div className="col-12 col-md-4 p-1">
                <div className="form-floating">
                    <select onChange={e => HandlerFiltroEntidad(e.target.value)} value={filtroEntidad} id="entidad-vehiculo" type="select" className="form-select f-actor-texto" >
                        <option value="-">Seleccionar</option>
                        {selectEntidades}                          
                    </select>
                    <label htmlFor="entidad-vehiculo">Entidad Emisora</label>
                </div>
            </div>
            <div className="col-12 col-md-2">
                <button onClick={e=>ObtenerListaVehiculos(filtroPlaca, filtroDescripcion, filtroEntidad, 1)} className="btn btn-primary my-1 w-100">Filtrar</button>
                <button onClick={QuitarFiltros} className="btn btn-secondary w-100">Quitar filtros</button>
            </div>
            {/* TABLA */}
            <div className="contenedor-tabla py-4">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Placa</th>
                            <th>N° Autorizacion Especial</th>
                            <th>Entidad Emisora</th>
                            <th>Descripción</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listaVehiculos.length > 0 ? listaVehiculos.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.placa}</td>
                                    <td>{item.autorizacion}</td>
                                    <td>{item.entidad}</td>
                                    <td>{item.descripcion}</td>
                                    <td>
                                        <Link to={`/detalle-vehiculo/${item.placa}`} className="btn btn-primary">
                                        Detalles
                                        </Link>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={5} className="text-secondary text-center fs-4 fw-semibold">Sin resultados</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-center">
                {paginador}
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_LISTAR_VEHICULOS = process.env.REACT_APP_URL_LISTAR_VEHICULOS
const URL_ENTIDADES_EMISORAS = process.env.REACT_APP_URL_ENTIDADES_EMISORAS;
//#endregion